import gql from 'graphql-tag'

export default gql`mutation setSchedule($data: UserScheduleInput!){
    setSchedule(data: $data) @client
}`